export const PersonFocusIcon = ({
                                    color = '#2D1AFF',
                                    width = 125,
                                    height = 125,
                                }: {
    color?: string
    width?: number
    height?: number
}) => (
    <svg width={width} height={height} viewBox="0 0 125 125" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M0 62.5C0 27.9822 27.9822 0 62.5 0C97.0178 0 125 27.9822 125 62.5C125 97.0178 97.0178 125 62.5 125C27.9822 125 0 97.0178 0 62.5Z"
            fill={color}
            fillOpacity="0.1"
        />
        <g clipPath="url(#clip0_3506_5356)">
            <path
                d="M56.75 53.875C56.75 55.4 57.3558 56.8625 58.4341 57.9409C59.5125 59.0192 60.975 59.625 62.5 59.625C64.025 59.625 65.4875 59.0192 66.5659 57.9409C67.6442 56.8625 68.25 55.4 68.25 53.875C68.25 52.35 67.6442 50.8875 66.5659 49.8091C65.4875 48.7308 64.025 48.125 62.5 48.125C60.975 48.125 59.5125 48.7308 58.4341 49.8091C57.3558 50.8875 56.75 52.35 56.75 53.875Z"
                stroke={color}
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M39.5 51V45.25C39.5 43.725 40.1058 42.2625 41.1841 41.1841C42.2625 40.1058 43.725 39.5 45.25 39.5H51"
                stroke={color}
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M39.5 74V79.75C39.5 81.275 40.1058 82.7375 41.1841 83.8159C42.2625 84.8942 43.725 85.5 45.25 85.5H51"
                stroke={color}
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M74 39.5H79.75C81.275 39.5 82.7375 40.1058 83.8159 41.1841C84.8942 42.2625 85.5 43.725 85.5 45.25V51"
                stroke={color}
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M74 85.5H79.75C81.275 85.5 82.7375 84.8942 83.8159 83.8159C84.8942 82.7375 85.5 81.275 85.5 79.75V74"
                stroke={color}
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M51 74C51 72.475 51.6058 71.0125 52.6841 69.9341C53.7625 68.8558 55.225 68.25 56.75 68.25H68.25C69.775 68.25 71.2375 68.8558 72.3159 69.9341C73.3942 71.0125 74 72.475 74 74"
                stroke={color}
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_3506_5356">
                <rect width="69" height="69" fill="white" transform="translate(28 28)"/>
            </clipPath>
        </defs>
    </svg>
)
